import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import SetupUsers from './SetupUsers';

const SetupUsersBridge = react2angular(SetupUsers);
export default SetupUsersBridge;
